import React, { useRef, useState } from 'react';
import debounce from 'lodash/debounce';
import { matchSorter } from 'match-sorter';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import CardMedia from '@/components/card/CardMedia/CardMedia';
import { urlCruise } from '@/utils/browser';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import { GridContainer } from '@/features/cruise/region/RegionList/RegionList.styles';

export interface FilterListItemsProps<T> {
  initialData: [CruiseItineraryType];
  counter?: number;
  placeholder: string;
  handleFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleReset?: () => void;
}

// function FilterListItems<T>({ initialData, keys, placeholder, children, ...props }: FilterListItemsProps<T>) {
// https://react-typescript-cheatsheet.netlify.app/docs/advanced/patterns_by_usecase#generic-components
const FilterListItems = <T,>({
  initialData,
  placeholder,
  handleFilter,
  handleReset,
  counter: counterProp,
}: FilterListItemsProps<T>) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<[CruiseItineraryType]>([...initialData]);

  const _handleFilter = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    if (typeof handleFilter === 'function') {
      handleFilter(event);
    } else {
      const value = event.target.value;

      if (value.length === 0) {
        setData((prevState) => [...initialData]);
      } else {
        debounce(() => {
          const results: any = matchSorter([...initialData], value, { keys: ['title'] });
          setData((prevState) => results);
        }, 200)();
      }
    }
  };

  const _handleReset = (): void => {
    if (inputRef.current?.value) {
      inputRef.current.value = '';
      if (typeof handleReset === 'function') {
        handleReset();
      } else {
        setData(() => initialData);
      }
    }
  };

  let counter;
  if (typeof counterProp !== 'undefined') {
    counter = counterProp;
  } else {
    counter = data.length;
  }

  // TODO: BRING BACK THE FILTER INPUT FORM
  return (
    <>
      {/*<FilterContainer>*/}
      {/*  <form onSubmit={(e) => e.preventDefault()}>*/}
      {/*    <TextField*/}
      {/*      ref={inputRef}*/}
      {/*      type="text"*/}
      {/*      placeholder={placeholder}*/}
      {/*      name="filter"*/}
      {/*      onChange={_handleFilter}*/}
      {/*      bgIcon="search"*/}
      {/*    />*/}
      {/*  </form>*/}
      {/*</FilterContainer>*/}
      {/*<FilterResult fade={!!inputRef.current?.value}>*/}
      {/*  <span>*/}
      {/*    <strong>{counter}</strong> ite{counter > 1 ? 'ns' : `m`} encontrado(s)*/}
      {/*  </span>*/}
      {/*  <span>*/}
      {/*    <button onClick={_handleReset}>limpar filtro</button>*/}
      {/*  </span>*/}
      {/*</FilterResult>*/}
      <GridContainer>
        {initialData.map(({ title, slug, permalink, summary, media }, index) => (
          <CardFeatured key={slug}>
            <CardMedia media={media} href={urlCruise(permalink)} priority={index <= 3} />
            <CardTitle as="h2" textCase="uppercase">
              <Link href={urlCruise(permalink)}>{title}</Link>
            </CardTitle>
            <CardBody>{summary}</CardBody>
            <CardFooter>
              <Button href={urlCruise(permalink)} block arrow>
                Veja o Roteiro
              </Button>
            </CardFooter>
          </CardFeatured>
        ))}
      </GridContainer>
    </>
  );
};

export default FilterListItems;
